import { quickVar } from '../lib/gsap';
import { prefersReducedMotion } from '../lib/lenis';

// Pointer flourishes: the panel spotlight, card tilt and the magnetic pull on
// primary buttons. All three only write CSS custom properties, and all three are
// skipped on touch devices and under reduced motion.
const finePointer = (): boolean =>
  window.matchMedia('(hover: hover) and (pointer: fine)').matches;

export function initPointerFx(): void {
  if (prefersReducedMotion() || !finePointer()) return;

  // ---- Spotlight ----------------------------------------------------
  document.querySelectorAll<HTMLElement>('[data-spotlight]').forEach((el) => {
    el.addEventListener(
      'mousemove',
      (event) => {
        const rect = el.getBoundingClientRect();
        el.style.setProperty('--mx', `${((event.clientX - rect.left) / rect.width) * 100}%`);
        el.style.setProperty('--my', `${((event.clientY - rect.top) / rect.height) * 100}%`);
      },
      { passive: true },
    );
  });

  // ---- Card tilt ----------------------------------------------------
  const maxTilt = 5;

  document.querySelectorAll<HTMLElement>('[data-tilt]').forEach((el) => {
    const setTiltX = quickVar(el, '--tilt-x', 'deg');
    const setTiltY = quickVar(el, '--tilt-y', 'deg');
    const setGlareX = quickVar(el, '--gx', '%');
    const setGlareY = quickVar(el, '--gy', '%');

    el.addEventListener(
      'mousemove',
      (event) => {
        const rect = el.getBoundingClientRect();
        const px = (event.clientX - rect.left) / rect.width;
        const py = (event.clientY - rect.top) / rect.height;
        setTiltX((px - 0.5) * maxTilt * -2);
        setTiltY((0.5 - py) * maxTilt);
        setGlareX(px * 100);
        setGlareY(py * 100);
      },
      { passive: true },
    );

    el.addEventListener('mouseleave', () => {
      setTiltX(0);
      setTiltY(0);
      setGlareX(50);
      setGlareY(50);
    });
  });

  // ---- Magnetic buttons ---------------------------------------------
  const pull = 0.18;

  document.querySelectorAll<HTMLElement>('[data-magnetic]').forEach((el) => {
    const setPullX = quickVar(el, '--pull-x', 'px', 0.3);
    const setPullY = quickVar(el, '--pull-y', 'px', 0.3);

    el.addEventListener(
      'mousemove',
      (event) => {
        const rect = el.getBoundingClientRect();
        setPullX((event.clientX - (rect.left + rect.width / 2)) * pull);
        setPullY((event.clientY - (rect.top + rect.height / 2)) * pull);
      },
      { passive: true },
    );

    el.addEventListener('mouseleave', () => {
      setPullX(0);
      setPullY(0);
    });
  });
}
